import apiClient from './apiClient';
import { TransactionsApiResponse, TransactionDetailApiResponse } from '../types/transaction';
import { toLegacyListResponse } from '../utils/normalizePaginatedResponse';
import type { Transaction } from '../types/transaction';

const TRANSACTIONS_PATH = 'transactions';

const statusPath = (status: string): string => {
  switch (status) {
    case 'successful':
      return `${TRANSACTIONS_PATH}/successful`;
    case 'failed':
      return `${TRANSACTIONS_PATH}/failed`;
    case 'pending':
      return `${TRANSACTIONS_PATH}/pending`;
    default:
      return TRANSACTIONS_PATH;
  }
};

export const getTransactions = async (
  status = 'all',
  page = 1,
  limit = 10,
  _search = '',
  startDate = '',
  endDate = ''
): Promise<TransactionsApiResponse> => {
  try {
    const params: Record<string, string | number> = { page, limit };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await apiClient.get(statusPath(status), { params });

    return toLegacyListResponse<Transaction, 'transactions'>(
      response.data,
      'transactions',
    );
  } catch (error) {
    console.error('Failed to fetch transactions:', error);
    return {
      status: 'error',
      data: {
        transactions: [],
        pagination: { currentPage: 1, totalPages: 0, totalItems: 0, limit, hasMore: false },
      },
    } as TransactionsApiResponse;
  }
};

export const getTransactionById = async (
  transactionId: string
): Promise<TransactionDetailApiResponse> => {
  const response = await apiClient.get<TransactionDetailApiResponse>(
    `${TRANSACTIONS_PATH}/${transactionId}`
  );
  return response.data;
};

/** List export PDF is not available; backend only supports per-user PDF. */
export const downloadTransactionsPDF = async (_status = 'all'): Promise<Blob> => {
  throw new Error('Transaction list PDF export is not available');
};
